import BannerSliderBase from './BannerSliderBase';
export const BannerSlider = {
  BannerSlider_1_1: ({ item }) => {
    return <BannerSliderBase item={item} imageWidth={45} aspectRatio={1 / 1}></BannerSliderBase>;
  },
  BannerSlider_1_5_2: ({ item }) => {
    return <BannerSliderBase item={item} imageWidth={45} aspectRatio={3 / 4}></BannerSliderBase>;
  },
  BannerSlider_2_1: ({ item }) => {
    return <BannerSliderBase item={item} imageWidth={45} aspectRatio={2 / 1}></BannerSliderBase>;
  },
  BannerSlider_3_2: ({ item }) => {
    return <BannerSliderBase item={item} imageWidth={45} aspectRatio={3 / 2}></BannerSliderBase>;
  },
  BannerSlider_1_1_round: ({ item }) => {
    return <BannerSliderBase item={item} imageWidth={45} aspectRatio={1 / 1}></BannerSliderBase>;
  },
  BannerSlider_1_5_2_round: ({ item }) => {
    return <BannerSliderBase item={item} imageWidth={45} aspectRatio={3 / 4}></BannerSliderBase>;
  },
  BannerSlider_2_1_round: ({ item }) => {
    return <BannerSliderBase item={item} imageWidth={45} aspectRatio={2 / 1}></BannerSliderBase>;
  },
  BannerSlider_3_2_round: ({ item }) => {
    return <BannerSliderBase item={item} imageWidth={45} aspectRatio={3 / 2}></BannerSliderBase>;
  },
  BannerSlider_full: ({ item }) => {
    return <BannerSliderBase item={item} imageWidth={100} aspectRatio={1 / 2.3}></BannerSliderBase>;
  },
  BannerSlider_dynamic: ({ item }) => {
    return <BannerSliderBase item={item} ></BannerSliderBase>;
  },
};
